import React from 'react';

export default function MediaPlaceholder({ label = "PROJECT IMAGE", aspectRatio = "aspect-video" }) {
  return (
    <div className={`relative w-full h-full bg-[#0B0C0F] border border-[#242832] overflow-hidden flex items-center justify-center ${aspectRatio}`}>
      {/* Subtle Abstract Background */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" 
           style={{ backgroundImage: 'radial-gradient(#2F6BFF 1px, transparent 1px)', backgroundSize: '40px 40px' }}>
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#2F6BFF]/5 via-transparent to-transparent"></div>
      
      {/* Discreet Corner Label */}
      <div className="absolute bottom-6 right-6">
        <span className="text-[10px] font-semibold tracking-[0.2em] text-[#A7ADB8]/40 uppercase select-none">
          {label}
        </span>
      </div>

      {/* Subtle Logo Mark */}
      <div className="text-[#F7F8FA] text-4xl font-bold select-none opacity-[0.02] tracking-tighter">
        MAXMARK.
      </div>
    </div>
  );
}